/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class CreateLockFilterRequest {
    getFixupPrototypeFunction() { return CreateLockFilterRequest.fixupPrototype; }

    static newInstance(model: Partial<CreateLockFilterRequest>): CreateLockFilterRequest {
        let obj = Object.assign(new CreateLockFilterRequest(), model);
        CreateLockFilterRequest.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<CreateLockFilterRequest>): CreateLockFilterRequest {
        if (!model) return null;
        return CreateLockFilterRequest.newInstance(<CreateLockFilterRequest> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: CreateLockFilterRequest) {
        if (!obj) return;

        models.CreateLockFilterRequest.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: CreateLockFilterRequest): boolean {
        Object.setPrototypeOf(obj, CreateLockFilterRequest.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.regions) {
            for (let val of this.regions) {
                models.ScopeFilterRegion.fixupPrototype(val);
            }
        }
        if (this.resource_groups) {
            for (let val of this.resource_groups) {
                models.ScopeResourceGroup.fixupPrototype(val);
            }
        }
        if (this.zone) {
            for (let val of this.zone) {
                models.ScopeFilterZone.fixupPrototype(val);
            }
        }
    }

    /**
     * Displays the list of regions
     */
    regions: Array<models.ScopeFilterRegion>;

    /**
     * Displays the list of resources
     */
    resources: Array<string>;

    /**
     * Displays the list of resource groups
     */
    resource_groups: Array<models.ScopeResourceGroup>;

    /**
     * applied tags for lock
     */
    tags: Array<any>;

    /**
     * List zone of cloud account
     */
    zone: Array<models.ScopeFilterZone>;

}
